module.exports = __webpack_public_path__ + "static/media/boonda.66fa43cb.jpeg";